import * as R from 'ramda'

import { SET_EMAIL_SURVEY_SUBSCRIPTION, SET_ENTITIES } from 'actions'

const initialState = {
  allIds: [],
  entities: {},
}

const emailSurveySubscription = (state = initialState, action) => {
  const { allIds, entities } = state
  switch (action.type) {
    case SET_EMAIL_SURVEY_SUBSCRIPTION:
      return {
        ...state,
        entities: R.merge(state.entities, {
          [action.surveySubscription.id]: action.surveySubscription,
        }),
      }
    case SET_ENTITIES:
      return {
        allIds: R.union(allIds, action.allIds.emailSurveySubscription),
        entities: R.merge(entities, action.entities.emailSurveySubscription),
      }
    default:
      return state
  }
}

export default emailSurveySubscription

export const getEmailSurveySubscription = (state, ids) => ids.map((id) => state.entities[id])



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/reducers/data/emailSurveySubscription.js